import { z } from 'zod';
import { dateInInterval } from '../global.validation';

export const paaMilestoneDraftValidationSchema = (minDate?: Date) =>
  z.object({
    realisationEnvisagees: z
      .string()
      .min(1, 'Le champ "realisation envisagees" ne doit pas être vide')
      .max(250, 'ce champ ne doit pas dépasser 250 caractères.'),
    'typeMarcher.id': z.number({ required_error: 'Le type de marché est obligatoire' }).min(1, 'Le type de marché ne doit pas être vide'),
    beneficiaire: z
      .string({
        required_error: 'Le bénéficiaire est obligatoire',
      })
      .optional(),
    'modePassation.id': z.number({ required_error: 'Le mode de sélection est obligatoire' }),
    'imputationBudgetaire.id': z
      .number({ required_error: "L'imputation budgétaire est obligatoire" })
      .min(1, "L'imputation budgétaire ne doit pas être vide")
      .optional(),
    datePrevLps: dateInInterval({
      invalid_type_error: 'La date à laquelle le processus de sélection devrait commencer est obligatoire',
      required_error: 'La date à laquelle le processus de sélection devrait commencer est obligatoire',
      min: minDate,
    }),
  });

export const paaMilestoneFloawableValidationSchema = (minDate?: Date) => paaMilestoneDraftValidationSchema(minDate);

export const paaMilestoneFundingValidationSchema = z.object({
  sourceFinancement: z.object({
    id: z.number({ required_error: 'Le type de financement est obligatoire' }).min(1, 'Le type de financement ne doit pas être vide'),
  }),
  monnaieId: z.number({ required_error: 'Le type de monnaie est obligatoire' }).min(1, 'Le type de monnaie ne doit pas être vide'),
  budgetEstimer: z.number({
    required_error: 'Le budget doit être renseigné',
  }),
});

export const paaMilestoneSlotsValidationSchema = z.object({
  description: z
    .string({ required_error: 'Le lot ne doit pas être vide' })
    .min(1, 'Le lot ne doit pas être vide')
    .max(250, 'ce champ doit faire moins de 250 caractères'),
  budget: z
    .number({
      required_error: 'Le budget doit être renseigné',
    })
    .optional(),
});
